





























































































































































































import Vue from "vue";
import Footer from "../components/master/Footer.vue";
import ImageInput from "../components/common/imageinput.vue";
import PasswordInput from "../components/common/passwordInput.vue";
import UserAvatar from "../components/common/user-avatar.vue";
import AbpBase from "../lib/abpbase";
import { VueTelInput } from "vue-tel-input";
import PrivacyModal from "../components/legal-docs/privacy-modal.vue";
import TermsModal from "../components/legal-docs/terms-modal.vue";

let _: any = require("lodash");
const prefixCls = "wizard";

export default AbpBase.extend({
  components: {
    Footer,
    ImageInput,
    PasswordInput,
    UserAvatar,
    VueTelInput,
    PrivacyModal,
    TermsModal,
  },
  data() {
    return {
      showPrivacy: false,
      showTerms: false,
      registrationModel: {
        id: 0,
        name: "",
        emailAddress: "",
        password: "",
        passwordConfirm: "",
        accountName: "",
        phoneNumber: "",
        logoImage: null,
      },
      bindPhoneProps: {
        mode: "international",
        defaultCountry: "US",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: "Mobile Phone (for two-factor authentication)",
        required: true,
        enabledCountryCode: false,
        enabledFlags: true,
        preferredCountries: ["US"],
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: "off",
        name: "telephone",
        maxLen: 25,
        wrapperClasses: "",
        inputClasses: "",
        dropdownOptions: {
          disabledDialCode: false,
        },
        inputOptions: {
          showDialCode: false,
        },
      },
      has_eight_characters: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      saving: false,
      currentStep: "name",
      currentStepIndex: 0,
      confirmation: null,
      rules: {
        name: [
          {
            required: true,
            message: "Please fill in your full name",
            trigger: "blur",
          },
        ],
        accountName: [
          {
            required: true,
            message: "Please fill in your account name",
            trigger: "blur",
          },
          {
            type: "string",
            max: 30,
            message: "Max 30 characters.",
            trigger: "change",
          },
        ],
        phoneNumber: [
          {
            required: true,
            message: "Please fill in your mobile phone number",
            trigger: "blur",
          },
        ],
        emailAddress: [
          {
            required: true,
            message: "Please enter email address",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Should be an email address.",
            trigger: "change",
          },
        ],
        password: [
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("Please fill in the password"));
              } else {
                if ((this as any).checkPassword(value)) {
                  if ((this as any).registrationModel.passwordConfirm !== "") {
                    (this.$refs.passwordForm as any).validateField("passwordConfirm");
                  }
                } else {
                  callback(new Error("Not a valid password."));
                }

                callback();
              }
            },
            trigger: "blur",
          },
        ],
        passwordConfirm: [
          {
            required: true,
            message: "Please confirm the password",
            validator: (rule, value, callback) => {
              if (value !== (this as any).registrationModel.password) {
                callback(new Error("Passwords do not match!"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    dotsClasses() {
      return [`${prefixCls}-dots`, `${prefixCls}-dots-inside`];
    },
  },
  methods: {
    checkPassword(input) {
      let password = input || this.registrationModel.password;
      this.has_eight_characters = password && password.length > 7;
      this.has_number = /\d/.test(password);
      this.has_lowercase = /[a-z]/.test(password);
      this.has_uppercase = /[A-Z]/.test(password);
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(password);

      return this.has_eight_characters && this.has_number && this.has_lowercase && this.has_uppercase && this.has_special;
    },
    handlerWizardStep(offset) {
      let steps = ["name", "password", "account", "loading", "confirmation"];
      let nextStepIndex = _.findIndex(steps, (step) => step === this.currentStep) + offset;
      this.currentStepIndex = nextStepIndex;
      this.currentStep = steps[nextStepIndex];
    },
    nextStep() {
      if (this.currentStep !== "loading" && this.currentStep !== "confirmation") {
        (this.$refs[this.currentStep + "Form"] as any).validate(async (valid: boolean) => {
          if (valid) {
            if (this.currentStep === "account") {
              await this.signUp();
            } else {
              this.handlerWizardStep(1);
            }
          }
        });
      }
    },
    handleGoToLogin() {
      this.$Modal.remove();
      this.$router.push({
        name: "login",
      });
    },
    sendEmailConfirmation() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let context = this;

      // this.$Message.loading({
      //   content: "Send Email Confirmation...",
      //   duration: 0,
      // });

      let requestData = {
        emailAddress: context.registrationModel.emailAddress,
      };

      context.$store.dispatch("account/sendEmailAddressConfirmation", requestData).then((response) => {
        // setTimeout(() => {
        //   context.$Message.destroy();
        // }, 500);
        target.disabled = false;
        context.$Notice.success({
          desc: "Your email address confirmation is sent. Please check your email box to confirm and activate your account.",
          duration: 3,
        });
      });
    },
    validatePhoneNumber() {
      let field = this.$refs.PhoneNumberField as any;
      field.validate("");
    },
    async signUp() {
      let context = this;
      context.handlerWizardStep(1);

      await this.$store
        .dispatch({
          type: "account/register",
          data: {
            name: this.registrationModel.name,
            surname: this.registrationModel.name,
            userName: this.registrationModel.emailAddress,
            emailAddress: this.registrationModel.emailAddress,
            password: this.registrationModel.password,
            billingAccountName: this.registrationModel.accountName,
            phoneNumber: this.registrationModel.phoneNumber,
            logoImage: this.registrationModel.logoImage ? this.registrationModel.logoImage.imageURL : null,
          },
        })
        .then((response) => {
          if (response.success === true) {
            this.confirmation = response;
            context.handlerWizardStep(1);
          } else {
            this.$Modal.error({
              title: "Oops!",
              render: (h) => {
                return h("p", [h("span", {}, `It looks like ("${this.registrationModel.emailAddress}") already has an account. `), h("a", { on: { click: this.handleGoToLogin } }, "Sign in")]);
              },
            });

            context.handlerWizardStep(-3);
          }
        })
        .catch((error) => {});
    },
  },
});
